import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../../../services/filtering/filter-form-render-service/';
import messages, { StatusMessages } from './messages';

export const STATUS = 'status';

export default {
  id: STATUS,
  type: OptionFormTypes.TYPE_IS_RADIO_OPTIONS,
  filterValue: STATUS,
  displayName: (appliedFilters) => {
    const statusFilters = appliedFilters.filter((filter) => filter.filterById === STATUS);
    if (statusFilters.length === 0) {
      return <FormattedMessage {...messages.status} />;
    }
    if (statusFilters.length === 1) {
      const statusKey = statusFilters[0].criterionArgumentValue;
      return <FormattedMessage {...StatusMessages[statusKey]} />;
    }
    return <FormattedMessage {...messages.multipleStatuses} />;
  },
  render: (criteriaInformations, existingFiltersHelpers) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_IS_RADIO_OPTIONS, criteriaInformations, existingFiltersHelpers);
  },
};
